import axios from "axios";
import {
  FETCH_MANDANT_DATA,
  FETCH_MANDANT_LOGO,
  NEW_MANDANT_DATA,
  FETCH_MANDANT_ORDER_LIMIT
} from "./types/mandant-types";

export const fetchMandantData = (mandantRequestData) => async dispatch => {
  try {
    const response = await axios[mandantRequestData.request.type](mandantRequestData.url, mandantRequestData.json);
    if (!response) {
      throw new Error("Es sind keine Mandantendaten vorhanden");
    }
    if (
      response.config &&
      String(response.config.url).match(/\/mandant\/\d+/) &&
      response.data &&
      response.data.header &&
      "NO_DATA" === response.data.header.status
    ) {
      const match = String(response.config.url).match(/\/mandant\/(\d+)/);
      // copy last values to new mandant
      const mandantdaten = response.data;
      if (!mandantdaten.mandant) mandantdaten.mandant = {};
      mandantdaten.mandant.gpNummer = match[1];
      return dispatch({ type: NEW_MANDANT_DATA, mandantdaten });
    }
    dispatch({ type: FETCH_MANDANT_DATA, mandantdaten: response.data });
    return response.data;
  } catch (e) {
    console.error(e);
    throw new Error(`e9: ${e.message}`);
  }
};

export const fetchMandantLogo = (mandantRequestData) => async dispatch => {
  try {
    const axiosCall = axios.create();
    const response = await axiosCall[mandantRequestData.request.type](mandantRequestData.url, mandantRequestData.json);
    if (!response || !response.headers) return;
    if (String(response.headers["content-type"]).match(/image\/svg\+xml/)) {
      dispatch({
        type: FETCH_MANDANT_LOGO, logo: "data:" + response.headers["content-type"] + "," + encodeURIComponent(response.data)
      });
    }
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const fetchMandantOrderLimit = (requestData) => async dispatch => {
  try {
    const response = await axios[requestData.request.type](requestData.url, requestData.json);
    if (!response) {
      throw new Error("Keine Mandant OrderLimit Daten vorhanden");
    }
    dispatch({ type: FETCH_MANDANT_ORDER_LIMIT, orderLimit: response.data });
    return response.data;
  } catch (e) {
    console.error(e);
    throw new Error(`eOrderLimit: ${e.message}`);
  }
};

export const deleteMandantData = (getMandantUrl) => async dispatch => {
  await axios.delete(getMandantUrl);
  dispatch({ type: FETCH_MANDANT_DATA, mandantdaten: { mandant: {} } });
};
